import { BarMenuListProps } from './models/IBarMenuListProps';
import BarGuideMenuList from './pages/BarGuideMenuList';

export default function BarGuideMenuFeature({ barInfoId, barInfoName, onClose }: BarMenuListProps) {
  return (
    <>
      <BarGuideMenuList barInfoId={barInfoId} barInfoName={barInfoName} onClose={onClose} />
    </>
  );
}
